import { ParamConfig } from "../../utils/params/ParamsConfig";
export function TexturesFolderParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.textures = ParamConfig.FOLDER(null);
    }
  };
}
